import { inject, Injectable } from '@angular/core';
import Keycloak from 'keycloak-js';
import { TaasUserDetails } from 'utimaco-common-ui-angular';
import { TaasJwtTokenDetails } from '../models/taas-jwt-token-details';

@Injectable({
  providedIn: 'root'
})
export class TaasUserService {

  private keycloak = inject(Keycloak);

  performLogout() {
    this.keycloak.logout();
  }

  async getCurrentUserDetails(): Promise<TaasUserDetails> {
    const tokenString = this.keycloak.token!;
    const tokenObject: TaasJwtTokenDetails = JSON.parse(atob(tokenString.split('.')[1]));
    const userDetails: TaasUserDetails = {
      givenName: tokenObject.given_name,
      familyName: tokenObject.family_name,
      email: tokenObject.email,
      initials: tokenObject.given_name.trim().substring(0, 1) + tokenObject.family_name.trim().substring(0, 1)
    }
    return userDetails;
  }
}
